import styled, { css } from 'styled-components';

import { defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledBalance = styled.h4<{ negativeBalance: boolean }>(
  ({ negativeBalance, theme }) => {
    return css`
      color: ${negativeBalance ? theme.base.colors.red.medium : theme.base.colors.black};
    `;
  }
);

StyledBalance.defaultProps = defaultThemeProp;
